module.exports = __webpack_public_path__ + "img/collar length.b5000037.png";